module.exports = __webpack_public_path__ + "7bc45818e19e1572b8203c33b2475d6b.png";